import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';

import { getNowWeekdayAndDate } from '@clearverify/utils';

import { PageLayout } from 'src/components/common';
import { InboxEmptyWrapper, InboxItemsListOnlyWithResources } from 'src/components/inboxItem';
import { useScreenInfo } from 'src/hooks/common';
import { useCurrentUserEmployer } from 'src/hooks/employer';
import { useInboxItemParamId, useInboxItems } from 'src/hooks/inboxItem';

import {
  contentStyles,
  contentWrapperStyles,
  inboxWrapperStyles,
  leftMenuWrapperStyles,
  mobileContentStyles,
  mobileContentWrapperStyles,
  paperStyles,
} from './styles';

export const InboxLayoutEmployerManager: React.FC<React.PropsWithChildren> = ({
  children: content,
}) => {
  const { isMobile } = useScreenInfo();

  const { employer, loading: employerLoading } = useCurrentUserEmployer();
  const loading = employerLoading;

  const homeSectionName = employer?.displayName ?? 'Home';
  const titleName = homeSectionName;

  const { isEmptyInbox } = useInboxItems();
  const inboxItemId = useInboxItemParamId();

  const renderInboxColumns = React.useCallback(() => {
    return (
      <Box sx={inboxWrapperStyles}>
        <Box sx={leftMenuWrapperStyles}>
          <InboxItemsListOnlyWithResources />
        </Box>
        <Box sx={contentWrapperStyles}>{content}</Box>
      </Box>
    );
  }, [content]);

  const renderMobileInboxColumns = React.useCallback(() => {
    if (isEmptyInbox) {
      return <InboxEmptyWrapper />;
    }

    if (inboxItemId) {
      return (
        <Box sx={inboxWrapperStyles}>
          <Box sx={mobileContentWrapperStyles}>{content}</Box>
        </Box>
      );
    }

    return (
      <Box sx={inboxWrapperStyles}>
        <InboxItemsListOnlyWithResources />
      </Box>
    );
  }, [content, inboxItemId, isEmptyInbox]);

  if (isMobile) {
    return <Box sx={mobileContentStyles}>{renderMobileInboxColumns()}</Box>;
  }

  return (
    <PageLayout
      titleContent={loading ? <Skeleton width={150} height={40} /> : titleName}
      topRightContent={<Typography color="grey.500">{getNowWeekdayAndDate()}</Typography>}
      paperSx={paperStyles}
    >
      <Box sx={contentStyles}>{renderInboxColumns()}</Box>
    </PageLayout>
  );
};
